export const LS_KEY_CONNECTED_CONNECTOR = 'connected-connector';
export const LS_KEY_HIDE_HIGHER_RISK_TOKENS_NOTICE = 'hide-risk-tokens-notice';
